import { render, staticRenderFns } from "./ReviewInspection.vue?vue&type=template&id=3d890a10&scoped=true&"
import script from "./ReviewInspection.vue?vue&type=script&lang=js&"
export * from "./ReviewInspection.vue?vue&type=script&lang=js&"
import style0 from "./ReviewInspection.vue?vue&type=style&index=0&id=3d890a10&prod&scoped=true&lang=css&"
import style1 from "./ReviewInspection.vue?vue&type=style&index=1&id=3d890a10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d890a10",
  null
  
)

export default component.exports